/* ============================================================================
FILE: po-oeuvres-prolongees-collection-fr-en-es-20260727.js
ROLE: Description trilingue protégée de la collection « Les œuvres prolongées ».
ROOT: [data-po-oeuvres-prolongees]
LANGUES: FR / EN / ES
STORAGE: po_lex_lang + goody_gp_lang
AUDIO: SpeechSynthesis, lecture du texte actif uniquement.
LIENS: Les œuvres prolongées + Peindre la ligne, dessiner la couleur.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_OEUVRES_PROLONGEES_COLLECTION_20260727__) return;
  window.__PO_OEUVRES_PROLONGEES_COLLECTION_20260727__ = true;

  var ROOT_SELECTOR = "[data-po-oeuvres-prolongees]";
  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis)
    ? window.speechSynthesis
    : null;

  var AUDIO_STATE = {
    root: null,
    chunks: [],
    index: 0,
    active: false
  };

  function clampStr(value){
    return value == null ? "" : String(value);
  }

  function escapeHTML(value){
    return clampStr(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  var CANONICAL_LINKS = {
    collection: "/collections/les-oeuvres-prolongees",
    formula: "/pages/peindre-la-ligne"
  };

  function pageLink(value, href, isCanonical){
    var classes = "po-op-collection__link";

    if (isCanonical) {
      classes += " po-op-collection__canonical notranslate";
    }

    return '<a class="' + classes + '"' +
      (isCanonical ? ' translate="no"' : "") +
      ' href="' + escapeHTML(href) + '">' +
      escapeHTML(value) +
      "</a>";
  }

  function canonical(value, href){
    if (href) return pageLink(value, href, true);

    return '<span class="po-op-collection__canonical notranslate" translate="no">' +
      escapeHTML(value) +
      "</span>";
  }

  var CANON = {
    series: canonical(
      "Les œuvres prolongées",
      CANONICAL_LINKS.collection
    ),
    singular: canonical(
      "L’œuvre prolongée",
      CANONICAL_LINKS.collection
    ),
    formula: canonical(
      "Peindre la ligne, dessiner la couleur",
      CANONICAL_LINKS.formula
    ),
    guadeloupe: canonical("Guadeloupe")
  };

  var CONTENT = {
    fr: {
      ui: {
        group: "Choix de la langue",
        audio: "Écouter",
        stop: "Arrêter",
        content: "Description de la collection Les œuvres prolongées"
      },
      paragraphs: [
        "La série «&nbsp;" + CANON.series + "&nbsp;» prend naissance en 2015-2016. Elle rassemble 45 œuvres, dont une seule avait alors été exposée en " + CANON.guadeloupe + ". Ces œuvres sont allées à la rencontre de publics d’ailleurs, tandis que leur mise en vente demeurait exceptionnelle. Trente-deux d’entre elles étaient destinées à être continuées en 2020, en vue d’une exposition particulière en " + CANON.guadeloupe + ". Celle-ci devait marquer le passage entre mes vingt premières années de carrière et les vingt années à venir, portées par un nouveau projet que je lancerais finalement en janvier 2025, après cinq années de refonte. Les conséquences économiques de la Covid-19 ont bouleversé cette trajectoire. À partir de 2022 seulement, j’ai pu récupérer les œuvres laissées en Floride et poursuivre leur accompagnement, comme on accompagne un enfant qui grandit.",

        CANON.singular + " est ce geste par lequel je rends visible la manière dont je dessine la couleur en peignant la ligne. " + CANON.formula + " révèle les strates demeurées en réserve et transforme une illusion voilée en une relance du discours de l’œuvre, tout en préservant son identité première. Ce qui s’affirme ici dépasse la reprise, la correction et la variation de l’incertain. Il s’agit d’un projet pensé dans le silence de la création, d’une continuation de l’œuvre par elle-même, d’une mise en lumière par laquelle le temps ouvre en elle un nouvel accès à ses tensions, à ses zones de condensation et d’émergence, ainsi qu’à ses lignes de poussée masquées par le désordre apparent du fond.",

        "Je peins la ligne de ces espaces qui semblaient clos, masqués, flous ou indéfinis afin de dessiner la couleur de ce qui était déjà là, dans le surgissement des souvenirs et la puissance constructrice des rencontres. " + CANON.singular + " questionne le droit de repentir, interroge la mémoire, affirme l’audace et respire la liberté propre à une forme qui continue de se penser, de se déployer et de se révéler tout en demeurant elle-même, tant que l’artiste garde la main posée sur elle. Elle ouvre ainsi le champ à cette question qui revient souvent&nbsp;: «&nbsp;Quand savez-vous que l’œuvre est terminée&nbsp;?&nbsp;»",

        "Cette question soulève de nombreux sujets sur lesquels nous reviendrons, car ces œuvres se prolongent également à travers des créations littéraires et poursuivent, par cette ouverture, leur devenir indéfiniment."
      ]
    },

    en: {
      ui: {
        group: "Language selection",
        audio: "Listen",
        stop: "Stop",
        content: "Description of the Les œuvres prolongées collection"
      },
      paragraphs: [
        "The series “" + CANON.series + "” began in 2015-2016. It brings together 45 works, only one of which had then been exhibited in " + CANON.guadeloupe + ". These works went out to meet audiences elsewhere, while their availability for sale remained exceptional. Thirty-two of them were intended to be continued in 2020 for a special exhibition in " + CANON.guadeloupe + ". The exhibition was meant to mark the passage between my first twenty years of career and the twenty years ahead, carried by a new project that I would ultimately launch in January 2025 after five years of reworking. The economic consequences of Covid-19 disrupted that trajectory. Only from 2022 onward was I able to recover the works left in Florida and continue accompanying them, as one accompanies a growing child.",

        CANON.singular + " is the gesture through which I make visible the way I draw colour by painting the line. The canonical formula “" + CANON.formula + "” — “to paint the line, to draw colour” — reveals strata that had remained in reserve and transforms a veiled illusion into a renewal of the work’s discourse, while preserving its first identity. What asserts itself here goes beyond resumption, correction and the variation of uncertainty. It is a project conceived in the silence of creation, a continuation of the work by itself, an illumination through which time opens within it a new access to its tensions, its zones of condensation and emergence, and the lines of thrust concealed by the apparent disorder of the background.",

        "I paint the line of those spaces that seemed closed, masked, blurred or undefined in order to draw the colour of what was already there, in the emergence of memories and the constructive power of encounters. " + CANON.singular + " questions the right of repentance, interrogates memory, asserts audacity and breathes the freedom proper to a form that continues to think itself, unfold and reveal itself while remaining itself, as long as the artist keeps a hand upon it. It thus opens the field to the question that so often returns: “When do you know that the work is finished?”",

        "This question raises many subjects to which we shall return, for these works are also prolonged through literary creations and, through this opening, continue their becoming indefinitely."
      ]
    },

    es: {
      ui: {
        group: "Selección de idioma",
        audio: "Escuchar",
        stop: "Detener",
        content: "Descripción de la colección Les œuvres prolongées"
      },
      paragraphs: [
        "La serie «&nbsp;" + CANON.series + "&nbsp;» nace en 2015-2016. Reúne 45 obras, de las cuales una sola había sido expuesta entonces en " + CANON.guadeloupe + ". Estas obras fueron al encuentro de públicos de otros lugares, mientras su puesta en venta siguió siendo excepcional. Treinta y dos de ellas estaban destinadas a ser continuadas en 2020, con vistas a una exposición particular en " + CANON.guadeloupe + ". Esta debía marcar el paso entre mis primeros veinte años de carrera y los veinte años venideros, llevados por un nuevo proyecto que finalmente lanzaría en enero de 2025, después de cinco años de refundición. Las consecuencias económicas de la Covid-19 trastornaron esta trayectoria. Solo a partir de 2022 pude recuperar las obras dejadas en Florida y proseguir su acompañamiento, como se acompaña a un niño que crece.",

        CANON.singular + " es el gesto mediante el cual hago visible la manera en que dibujo el color pintando la línea. La fórmula canónica «&nbsp;" + CANON.formula + "&nbsp;» — «&nbsp;pintar la línea, dibujar el color&nbsp;» — revela los estratos que habían permanecido en reserva y transforma una ilusión velada en una reactivación del discurso de la obra, preservando al mismo tiempo su identidad primera. Lo que aquí se afirma supera la reanudación, la corrección y la variación de lo incierto. Se trata de un proyecto pensado en el silencio de la creación, de una continuación de la obra por sí misma, de una puesta en luz mediante la cual el tiempo abre en ella un nuevo acceso a sus tensiones, a sus zonas de condensación y emergencia, así como a sus líneas de empuje ocultas por el desorden aparente del fondo.",

        "Pinto la línea de esos espacios que parecían cerrados, enmascarados, borrosos o indefinidos para dibujar el color de lo que ya estaba allí, en el surgimiento de los recuerdos y la potencia constructiva de los encuentros. " + CANON.singular + " cuestiona el derecho de arrepentimiento, interroga la memoria, afirma la audacia y respira la libertad propia de una forma que continúa pensándose, desplegándose y revelándose mientras permanece ella misma, mientras el artista mantenga la mano posada sobre ella. Abre así el campo a esta pregunta que vuelve a menudo: «&nbsp;¿Cuándo sabe que la obra está terminada?&nbsp;»",

        "Esta pregunta plantea numerosos temas a los que volveremos, pues estas obras también se prolongan a través de creaciones literarias y prosiguen, mediante esta apertura, su devenir indefinidamente."
      ]
    }
  };

  function normLang(raw){
    var value = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");

    if (value === "fr" || value.indexOf("fr-") === 0) return "fr";
    if (value === "en" || value.indexOf("en-") === 0) return "en";
    if (value === "es" || value.indexOf("es-") === 0) return "es";

    return "fr";
  }

  function readStoredLang(){
    var value = "";

    try {
      value = localStorage.getItem(STORAGE_KEY) || "";
    } catch(e) {
      value = "";
    }

    if (!value) {
      try {
        value = localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      } catch(_e) {
        value = "";
      }
    }

    return value ? normLang(value) : "";
  }

  function getLang(){
    var stored = readStoredLang();
    var htmlLang = "";

    if (stored) return stored;

    try {
      htmlLang = document.documentElement.getAttribute("lang") || "";
    } catch(e) {
      htmlLang = "";
    }

    return htmlLang ? normLang(htmlLang) : "fr";
  }

  function storeLang(lang){
    var resolved = normLang(lang);

    try {
      localStorage.setItem(STORAGE_KEY, resolved);
    } catch(e) {}

    try {
      localStorage.setItem(STORAGE_KEY_COMPAT, resolved);
    } catch(_e) {}

    try {
      document.documentElement.setAttribute("lang", resolved);
    } catch(__e) {}

    return resolved;
  }

  function paragraphHTML(paragraphs){
    return paragraphs.map(function(paragraph){
      return '<p class="po-op-collection__paragraph">' + paragraph + "</p>";
    }).join("");
  }

  function updateButtons(root, lang){
    var buttons = root.querySelectorAll("[data-po-lang]");

    Array.prototype.forEach.call(buttons, function(button){
      var active = normLang(button.getAttribute("data-po-lang")) === lang;

      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateUI(root, lang){
    var data = CONTENT[lang] || CONTENT.fr;
    var group = root.querySelector("[data-po-language-group]");
    var content = root.querySelector("[data-po-content]");
    var audio = root.querySelector("[data-po-audio]");

    root.setAttribute("lang", lang);
    root.setAttribute("aria-label", data.ui.content);

    if (group) group.setAttribute("aria-label", data.ui.group);
    if (content) content.setAttribute("aria-label", data.ui.content);

    if (audio) {
      audio.hidden = !AUDIO_SYNTH;
      audio.textContent = AUDIO_STATE.active && AUDIO_STATE.root === root
        ? data.ui.stop
        : data.ui.audio;
      audio.setAttribute(
        "aria-pressed",
        AUDIO_STATE.active && AUDIO_STATE.root === root ? "true" : "false"
      );
    }

    updateButtons(root, lang);
  }

  function renderRoot(root, lang){
    if (!root) return;

    var resolved = normLang(lang);
    var data = CONTENT[resolved] || CONTENT.fr;
    var content = root.querySelector("[data-po-content]");

    stopAudio();

    if (content) {
      content.classList.add("is-changing");

      window.setTimeout(function(){
        content.innerHTML = paragraphHTML(data.paragraphs);
        content.setAttribute("lang", resolved);
        content.classList.remove("is-changing");
      }, 80);
    }

    updateUI(root, resolved);
  }

  function applyLangEverywhere(lang){
    var resolved = normLang(lang);
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, function(root){
      renderRoot(root, resolved);
    });
  }

  function notifyLocaleChanged(lang){
    try {
      window.dispatchEvent(new CustomEvent("po:locale-changed", {
        detail: {
          lang: lang,
          source: "po-oeuvres-prolongees-collection"
        }
      }));
    } catch(e) {
      try {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("po:locale-changed", true, true, {
          lang: lang,
          source: "po-oeuvres-prolongees-collection"
        });
        window.dispatchEvent(event);
      } catch(_e) {}
    }
  }

  function setLang(lang){
    var resolved = storeLang(lang);

    applyLangEverywhere(resolved);
    notifyLocaleChanged(resolved);

    return resolved;
  }

  function cleanAudioText(text){
    return clampStr(text)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function splitAudioText(text, maxLength){
    var clean = cleanAudioText(text);
    var limit = maxLength || 210;
    var sentences;
    var chunks = [];
    var current = "";

    if (!clean) return chunks;

    sentences = clean.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g) || [clean];

    sentences.forEach(function(sentence){
      var part = sentence.trim();

      if (!part) return;

      if (part.length > limit) {
        var words = part.split(/\s+/);

        words.forEach(function(word){
          var candidate = current ? current + " " + word : word;

          if (candidate.length > limit && current) {
            chunks.push(current.trim());
            current = word;
          } else {
            current = candidate;
          }
        });

        return;
      }

      if ((current + " " + part).trim().length > limit && current) {
        chunks.push(current.trim());
        current = part;
      } else {
        current = (current + " " + part).trim();
      }
    });

    if (current) chunks.push(current.trim());

    return chunks;
  }

  function voiceFor(lang){
    if (!AUDIO_SYNTH || typeof AUDIO_SYNTH.getVoices !== "function") return null;

    var voices = AUDIO_SYNTH.getVoices() || [];
    var locale = lang === "en" ? "en" : (lang === "es" ? "es" : "fr");
    var exact = null;
    var partial = null;

    voices.some(function(voice){
      var code = clampStr(voice.lang).toLowerCase();

      if (!exact && code === locale) exact = voice;
      if (!partial && code.indexOf(locale + "-") === 0) partial = voice;

      return Boolean(exact);
    });

    return exact || partial || null;
  }

  function refreshAudioButtons(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      updateUI(root, lang);
    });
  }

  function resetAudioState(){
    AUDIO_STATE.root = null;
    AUDIO_STATE.chunks = [];
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = false;
    refreshAudioButtons();
  }

  function stopAudio(){
    if (AUDIO_SYNTH) {
      try {
        AUDIO_SYNTH.cancel();
      } catch(e) {}
    }

    resetAudioState();
  }

  function speakNext(){
    var root = AUDIO_STATE.root;
    var lang;
    var utterance;
    var voice;

    if (!AUDIO_SYNTH || !AUDIO_STATE.active || !root) {
      resetAudioState();
      return;
    }

    if (AUDIO_STATE.index >= AUDIO_STATE.chunks.length) {
      resetAudioState();
      return;
    }

    lang = normLang(root.getAttribute("lang") || getLang());
    utterance = new SpeechSynthesisUtterance(AUDIO_STATE.chunks[AUDIO_STATE.index]);
    voice = voiceFor(lang);

    utterance.lang = lang === "en" ? "en-US" : (lang === "es" ? "es-ES" : "fr-FR");
    utterance.rate = 0.94;
    utterance.pitch = 1;
    utterance.volume = 1;

    if (voice) utterance.voice = voice;

    utterance.onend = function(){
      AUDIO_STATE.index += 1;
      speakNext();
    };

    utterance.onerror = function(){
      resetAudioState();
    };

    AUDIO_SYNTH.speak(utterance);
  }

  function startAudio(root){
    var content;
    var text;

    if (!AUDIO_SYNTH || !root) return;

    if (AUDIO_STATE.active && AUDIO_STATE.root === root) {
      stopAudio();
      return;
    }

    stopAudio();

    content = root.querySelector("[data-po-content]");
    text = content ? content.textContent : "";

    AUDIO_STATE.root = root;
    AUDIO_STATE.chunks = splitAudioText(text, 210);
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = AUDIO_STATE.chunks.length > 0;

    refreshAudioButtons();

    if (AUDIO_STATE.active) speakNext();
  }

  function bindRoot(root){
    if (!root || root.getAttribute("data-po-bound") === "true") return;

    root.setAttribute("data-po-bound", "true");

    root.addEventListener("click", function(event){
      var langButton = event.target.closest("[data-po-lang]");
      var audioButton = event.target.closest("[data-po-audio]");

      if (langButton && root.contains(langButton)) {
        event.preventDefault();
        setLang(langButton.getAttribute("data-po-lang"));
        return;
      }

      if (audioButton && root.contains(audioButton)) {
        event.preventDefault();
        startAudio(root);
      }
    });
  }

  function initRoots(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      bindRoot(root);
      renderRoot(root, lang);
    });
  }

  window.addEventListener("po:locale-changed", function(event){
    var detail = event && event.detail ? event.detail : null;
    var lang = detail && detail.lang ? detail.lang : getLang();

    if (detail && detail.source === "po-oeuvres-prolongees-collection") return;

    applyLangEverywhere(lang);
  });

  window.addEventListener("storage", function(event){
    if (!event) return;

    if (event.key === STORAGE_KEY || event.key === STORAGE_KEY_COMPAT) {
      applyLangEverywhere(event.newValue || getLang());
    }
  });

  document.addEventListener("shopify:section:load", function(){
    initRoots();
  });

  document.addEventListener("shopify:section:unload", function(){
    stopAudio();
  });

  window.addEventListener("pagehide", function(){
    stopAudio();
  });

  window.PoOeuvresProlongeesCollectionFR_EN_ES_20260727 = {
    getLang: getLang,
    setLang: setLang,
    init: initRoots,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRoots, { once: true });
  } else {
    initRoots();
  }
})();
